
import React from "react";
import { Label } from "@/components/ui/label";
import PlacesAutocomplete from "@/components/common/PlacesAutocomplete";

interface LocationFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const LocationField = ({ 
  id, 
  label, 
  value, 
  onChange, 
  placeholder 
}: LocationFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <PlacesAutocomplete
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
};

export default LocationField;
